"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERMISSIONS = void 0;
exports.PERMISSIONS = {
    ATTENDANCES_IMAGE_CREATE: 'ATTENDANCES:IMAGE_CREATE',
    ATTENDANCE_EDIT_SHOW: 'ATTENDANCE_EDIT:SHOW',
    AUTO_GENERATE_SCHEDULE_GET: 'AUTO_GENERATE_SCHEDULE:GET',
    AVAILABILITY_BLOCK_CREATE: 'AVAILABILITY_BLOCK:CREATE',
    AVAILABILITY_LIMITS_VIEW: 'AVAILABILITY_LIMITS:VIEW',
    BUDGET_ESTIMATES_EDIT: 'BUDGET_ESTIMATES:EDIT',
    BUDGET_ESTIMATES_VIEW: 'BUDGET_ESTIMATES:VIEW',
    ECP_GET: 'ECP:GET',
    EMPLOYMENT_CONDITIONS_CREATE: 'EMPLOYMENT_CONDITIONS:CREATE',
    EXPORT_VIEW_GET: 'EXPORT_VIEW:GET',
    OPEN_SHIFTS_GET: 'OPEN_SHIFTS:GET',
    OPEN_SHIFTS_SETTING_SHOW: 'OPEN_SHIFTS:SETTING_SHOW',
    PAYMENTS_VIEW_GET: 'PAYMENTS_VIEW:GET',
    PAYROLL_VIEW_GET: 'PAYROLL_VIEW:GET',
    PERMISSIONS_VIEW_GET: 'PERMISSIONS_VIEW:GET',
    PRODUCTION_QUOTAS_GET: 'PRODUCTION_QUOTAS:GET',
    PRODUCTION_QUOTAS_SETTING_SHOW: 'PRODUCTION_QUOTAS:SETTING_SHOW',
    RECOMMENDED_SCHEDULE_VIEW: 'RECOMMENDED_SCHEDULE:VIEW',
    SESSION_RECORD_ENABLE: 'SESSION_RECORD:ENABLE',
    SMS_NOTIFICATION_SEND: 'SMS_NOTIFICATION:SEND',
    SUPPLEMENTARY_LOCATIONS_VIEW: 'SUPPLEMENTARY_LOCATIONS:VIEW',
    TRADE_SHIFTS_GET: 'TRADE_SHIFTS:GET',
    TRADE_SHIFTS_SETTING_SHOW: 'TRADE_SHIFTS:SETTING_SHOW',
    WORK_PLACES_CREATE: 'WORK_PLACES:CREATE',
    WORKING_RULES_CHECK_CHANGE: 'WORKING_RULES_CHECK:CHANGE',
    WORKING_RULES_GET: 'WORKING_RULES:GET',
    COMPANY_MANAGE_PERMISSIONS_HIDE: 'COMPANY_MANAGE_PERMISSIONS:HIDE',
    OVERTIME_COLLECTION_VIEW: 'OVERTIME_COLLECTION:VIEW',
    REVERSE_SUPPLEMENTARY_LOCATION_ASSIGN: 'REVERSE_SUPPLEMENTARY_LOCATION:ASSIGN',
    SHORTER_ABSENCE_NAME: 'SHORTER_ABSENCE_NAME',
    RCP_GEOLOCALIZATION: 'RCP_GEOLOCALIZATION',
    NEW_REPORTS_VIEW: 'NEW_REPORTS:VIEW',
    CALCULATE_SPMH_BASED_BONUS: 'CALCULATE_SPMH_BASED_BONUS',
    LANGUAGE_SETTINGS_SHOW: 'LANGUAGE_SETTINGS:SHOW',
    VALIDATE_REF_ID: 'VALIDATE_REF_ID',
    NEW_SCHEDULE_VIEW: 'NEW_SCHEDULE_VIEW:VIEW',
    OPENING_HOURS_VIEW: 'OPENING_HOURS:VIEW',
    COMPANY_MANAGE_LOCATIONS_SHOW_ASSIGN: 'COMPANY_MANAGE_LOCATIONS:SHOW_ASSIGN',
    ABSENCES_EDIT_SHOW: 'ABSENCES_EDIT:SHOW',
    EXPORT_GSN_SHOW: 'EXPORT_GSN:SHOW',
    ATTENDANCE_SURVEY: 'ATTENDANCE_SURVEY',
    IMPORT_SHIFTS_AND_ATTENDANCES: 'IMPORT_SHIFTS_AND_ATTENDANCES',
    ADP_EXPORT: 'ADP_EXPORT',
    BUDGET_TARGETS_EDIT: 'BUDGET_TARGETS:EDIT',
    APPROVE_PAYROLL_ENABLE: 'APPROVE_PAYROLL:ENABLE',
    MULTIPLE_ABSENCES_DURING_DAY_ENABLE: 'MULTIPLE_ABSENCES_DURING_DAY:ENABLE',
    AVA_BASED_HOLIDAYS_ENABLE: 'AVA_BASED_HOLIDAYS:ENABLE',
    LABELS_MANAGE: 'LABELS:MANAGE',
    ATTENDANCES_FROM_OTHER_LOCATIONS_GET: 'ATTENDANCES_FROM_OTHER_LOCATIONS:GET',
};
